import { useEffect, useState } from "react";
import {TbFileInvoice} from 'react-icons/tb'
import {MdOutlineAddBox} from 'react-icons/md'
import { Link, useParams } from "react-router-dom";
import withGuard from "../../utils/withGuard";
import InvListBasic from "../../components/invoice/InvListBasic";
import { useCurrent, useFetch } from "../../hooks";
import SearchInvoice from "../../components/SearchInvoice";
import { MwButton } from "../../components/ui";
import CardHeadeWithActions from "../../components/ui/CardHeadeWithActions";
import {BiSearch} from 'react-icons/bi'
import { useTranslation } from "react-i18next";
import { HiOutlineDocumentReport, HiOutlineDocumentText, HiOutlineUserGroup, HiOutlineCog } from "react-icons/hi";
import { MdDashboard, MdShoppingCart, MdExpandLess } from "react-icons/md";

const ManageInvoices = () => {
    const params = useParams();
    const [invoices,setInvoices] = useState([]);
        const [t] = useTranslation('global')
    
    const {currentTenantId,currentCompanyId,currentBranchId} = useCurrent();
    const [links,setLinks] = useState([]) 
    const [url,setUrl] = useState(`${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/invoices/${currentTenantId}/${currentCompanyId}/${currentBranchId}`);
    const {data:resultInv,loading:loading,refreshHandler} = useFetch(url);
    const [searchLoading,setSearchLoading] = useState(false);
    const baseUrl = `${process.env.REACT_APP_INV_API_SALES_SERVER_BASE_URL}/taxes/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;
    const { data: taxesData, loading: taxesLoading } = useFetch(baseUrl);
    console.log("localstoragetaxesDataot",taxesData)
    const currenciesBaseUrl = `${process.env.REACT_APP_INV_API_SALES_SERVER_BASE_URL}/currencies/${currentTenantId}/${currentCompanyId}`;
    const { data: currenciesData, loading: loadingCurrencies } = useFetch(currenciesBaseUrl);
    




    const invoicesHandler = async (newUrl=url) => {
        setUrl(newUrl)
    }
    
    const onChangeSearch = (newValue) => {
        //console.log(newValue)
        setLinks(newValue.links)
        setInvoices(newValue.data)
        setSearchLoading(false);
    }
    useEffect(() => {
        if(resultInv){
            setLinks(resultInv.links)
            setInvoices(resultInv.data);
            console.log('invoice data',resultInv);
        }
    },[resultInv]);

    useEffect(() => {
        if (taxesData) {
          console.log("localstoragetaxesData",taxesData)
          localStorage.setItem("taxesData", JSON.stringify(taxesData));
        }
      }, []);
      

    // useEffect(()=>{
    //     if(currentBranchId){
    //         invoicesHandler(`${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/invoices/${currentTenantId}/${currentCompanyId}/${currentBranchId}`);
    //     }
    // },[currentBranchId])
    
    return (
    <>
        <div className="flex flex-col gap-6 pb-3    ">
            <CardHeadeWithActions
                title={t("invoices.managePurchaseOrders")}
                icon={<HiOutlineDocumentText size={24} />}
            >
                <Link to={`/${params.tenant}/invoices/create`}>
                    <MwButton inGroup={true} type='saveBtn' classNameCustom="hover:shadow-lg transition-all duration-200 flex items-center gap-2">
                        <MdOutlineAddBox size={20}/>
                        {t("invoices.createPurchaseOrder")}
                    </MwButton>
                </Link>
            </CardHeadeWithActions>
            <div className="mt-[-10px] px-3">
            <div className=" bg-gradient-to-br from-white to-gray-50 rounded-3xl shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-100 p-6 h-full">
                <div className="flex gap-6">
                    <div className="flex-1  min-h-0">
                        <InvListBasic 
                            loading={loading || searchLoading} 
                            links={links} 
                            paginateHandler={invoicesHandler} 
                            data={invoices} 
                            currencies={currenciesData?.data || []}
                        /> 
                    </div>
                    <div className="w-80">
                        <SearchInvoice 
                            className='bg-white rounded-2xl shadow-sm border border-gray-200' 
                            withFullResults={true} 
                            setLoadingCallback={setSearchLoading} 
                            onChangeSearch={onChangeSearch} 
                            isOpen={false} 
                            withFilter={true} 
                        />
                    </div> 
                </div>
            </div>
        </div></div>
    </>
    )
}

export default withGuard(ManageInvoices)
